<template lang="pug">
  component(v-if="typedIcon"
        :is="typedIcon"
        :style="{ width, height}"
        :containerColor="theme"
        :clipPathId="fileId")
  generic-icon(v-else
        :class="themeClass" 
        :style="{ width, height}")
  
</template>

<script>
import CsvIcon from './svgComponents/CsvIcon.vue';
import DocIcon from './svgComponents/DocIcon.vue';
import LinkIcon from './svgComponents/LinkIcon.vue';
import OdpIcon from './svgComponents/OdpIcon.vue';
import OdsIcon from './svgComponents/OdsIcon.vue';
import OdtIcon from './svgComponents/OdtIcon.vue';
import PdfIcon from './svgComponents/PdfIcon.vue';
import PptIcon from './svgComponents/PptIcon.vue';
import RtfIcon from './svgComponents/RtfIcon.vue';
import TxtIcon from './svgComponents/TxtIcon.vue';
import XlsIcon from './svgComponents/XlsIcon.vue';
import GenericIcon from '../../assets/document/generic.vue';
import { IconsWithTypes } from '../../helpers/docIcon';

const mime = require('mime');

export default {
  name: 'aiqDocumentIcon',
  components: {
    CsvIcon,
    DocIcon,
    LinkIcon,
    OdpIcon,
    OdsIcon,
    OdtIcon,
    PdfIcon,
    PptIcon,
    RtfIcon,
    TxtIcon,
    XlsIcon,
    GenericIcon,
  },
  props: {
    theme: {
      type: String,
      default: 'blue',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '22px',
    },
    height: {
      type: String,
      default: '30px',
    },
    documentExtension: {
      type: String,
      default: '',
    },
    mimeType: {
      type: String,
      default: '',
    },
    fileId: {
      type: String,
      required: true,
    },
  },
  computed: {
    themeClass() {
      return {
        [`theme-${this.theme}-${this.dark ? 'dark' : 'light'}`]: true,
      };
    },
    typedIcon() {
      if (IconsWithTypes[this.mimeType]) {
        if (this.documentExtension === 'rtf') {
          // because .rtf files mime type is application/msword just like .doc files
          return IconsWithTypes[mime.getType('.rtf')];
        }
        return IconsWithTypes[this.mimeType];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Use this approach to change svg color
// brightness(0%) saturate(100%) are added to clean up existing color set in svg
// https://stackoverflow.com/questions/22252472/how-to-change-the-color-of-an-svg-element
// stroke: #89aaea
.theme-blue-light {
  filter: brightness(0%) saturate(100%) invert(69%) sepia(7%)
          saturate(3849%) hue-rotate(189deg) brightness(101%) contrast(84%);
}

.theme-blue-dark {
  filter: brightness(0%) saturate(100%) invert(46%) sepia(94%)
          saturate(226%) hue-rotate(181deg) brightness(99%) contrast(97%);
}

// stroke: #FFFFFF
.theme-white-light {
  filter: brightness(0%) saturate(100%) invert(91%) sepia(98%)
          saturate(0%) hue-rotate(343deg) brightness(105%) contrast(102%);
}

// stroke: #808080
.theme-white-dark {
  filter: brightness(0%) saturate(100%) invert(70%) sepia(0%)
          saturate(4859%) hue-rotate(327deg) brightness(72%) contrast(87%);
}
</style>
